import React, { Component } from 'react'
import PropTypes from 'prop-types'
import Table, { TableBody, TableCell, TableHead, TableRow, TableSortLabel } from 'material-ui/Table'
import {capitalize} from '../etc/pluralize'
import * as formatters from '../etc/formatters'
import {task_t} from '../etc/common-props'
import TaskInfo from './TaskInfo'
import { push, replace } from 'react-router-redux'
import {compose} from 'redux'
import {connect} from 'react-redux'
import { Switch, Route, Redirect } from 'react-router'
import withObjectDetails from '../hoc/object-details'
import Hidden from 'material-ui/Hidden'

let numeric = (field) => {
  switch(field)
  {
  case 'fixed_cost':
  case 'resource_cost':
  case 'total_cost':
    return true
  default:
    return false
  }
}

let statusStr = (value) => {
  switch(value)
  {
  case 'STARTED_AHEAD_OF_SCHEDULE':
    return 'Started, on schedule'
  case 'STARTED_BEHIND_SCHEDULE':
    return 'Started, behind schedule'
  case 'COMPLETE':
    return 'Complete'
  case 'NOT_STARTED_BEHIND_SCHEDULE':
    return 'Not started, behind schedule'
  case 'NOT_STARTED_ON_SCHEDULE':
    return 'Not started'
  default:
    throw Error('Invalid Task Status')
  }
}

let format = (field, value) =>
{
  switch(field)
  {
  case 'start':
  case 'finish':
    return formatters.dateFormatter(value)
  case 'duration':
    return formatters.duration(value)
  case 'resource_cost':
  case 'fixed_cost': 
  case 'total_cost':
    return formatters.currency(value)
  case 'status':
    return statusStr(value)
  default:
    return value
  }
}

let TaskList = ({tasks, fields, orderedBy, order, onRequestSort, onSelectObject}) => (
  <Table style={{tableLayout: 'auto'}}>
    <colgroup>
        {fields.map((field) => {
          let {style, hidden} = field
           
          style = style || {}
          hidden = hidden || {}
          return (<Hidden key={field.id} {...hidden}> <col style={style}/></Hidden>)
        })}
    </colgroup>
    <TableHead>
      <TableRow>
        {fields.map((field) => {
          let {id, label, style, hidden} = field
          style = style || {}
          hidden = hidden || {}
          
          id = id || field
          label = label || capitalize(id)
        return (<Hidden key={id} {...hidden}>
          <TableCell style={style} padding='dense' key={id} numeric={numeric(id)}>
            <TableSortLabel
              active={orderedBy === id}
              direction={order}
              onClick={(e)=>{onRequestSort(id)}}
            >
              {label}
            </TableSortLabel>
            
          </TableCell></Hidden>
        )})}
      </TableRow>
    </TableHead>
    <TableBody>
      {tasks.map( (task) => (
        <TableRow key={task.acttask_id} hover onClick={ev => onSelectObject(task)}>
          {fields.map( (field, i) => { 
            let {id, style, hidden} = field 
            style = style || {}
            hidden = hidden || {}
            
            id = id || field  
            return (<Hidden key={i} {...hidden}>
            <TableCell style={style} padding='dense' key={i} numeric={numeric(id)}>
              {format(id, task[id])}
            </TableCell></Hidden>
          )})}
        </TableRow>
      ))}
    </TableBody>
  </Table>
)

let supported_fields = [
  'name',
  'start',
  'finish',
  'duration',
  'status',
  'critical',
  'fixed_cost',
  'resource_cost',
  'total_cost',
  'wbs'
]

let tasklist_props = {
  tasks: PropTypes.arrayOf(task_t),
  fields: PropTypes.arrayOf(
    PropTypes.oneOf(supported_fields)
  ),
  onClick: PropTypes.func
}

let sort_props = {
  orderedBy: PropTypes.oneOf(supported_fields.concat([''])),
  order: PropTypes.oneOf(['asc', 'desc']),
  onRequestSort: PropTypes.func.isRequired
}

TaskList.propTypes = {
  ...tasklist_props,
  ...sort_props
}

let createCompareFn = (field, order) => (a, b) => {
  if (a[field] > b[field])
  {
    return order === 'asc' ? 1 : -1
  }
  else if (a[field] < b[field])
  {
    return order === 'asc' ? -1 : 1
  }
  else 
  {
    return 0
  }
}


class SortableTaskList extends Component {
  constructor(props)
  {
    let {default_order_by, default_order} = {
      default_order_by: props.fields[0],
      default_order: 'asc',
      ...props
    }
    super(props)
    this.state = {
      order_by: default_order_by,
      order: default_order
    }
  }

  static propTypes = {
    ...tasklist_props
  }

  setOrderBy = field =>
  {
    this.setState((prevState) => (
      {
        ...prevState,
        order_by: field,
        order: (prevState.order_by === '' || (prevState.order_by === field && prevState.order === 'desc')) ? 'asc' : 'desc'
      }))
  }

  render = () => { 
    var {tasks, fields, ...restProps} = this.props
    let {order_by, order} = this.state
    if (order_by !== '' )
    {
      tasks = tasks.sort(createCompareFn(order_by, order) )
    }
    return(
      <TaskList
        {...restProps}
        tasks={tasks}
        fields={fields}
        orderedBy={order_by}
        order={order}
        onRequestSort={this.setOrderBy}
      />
    )}
}


export default withObjectDetails(SortableTaskList, TaskInfo)
// export default SortableTaskList



// WEBPACK FOOTER //
// ./src/components/TaskList.js